export function formatPrice(price, lang = "ja") {
  if (!price) {
    return "";
  }

  if (lang === "ja") {
    if (/JPY\d+/.test(price)) {
      return `${new Intl.NumberFormat().format(
        parseInt(price.substr(3), 10)
      )}円`;
    }
  }

  return price;
}

export function formatPriceRange(lowest, highest, lang = "ja") {
  if (lang === "ja") {
    if (lowest || highest) {
      return `${formatPrice(lowest)} 〜 ${formatPrice(highest)}`;
    }
    return "";
  }
}
